export default function (context, value) {
  return new Promise((resolve, reject) => {
    message(context, {
      id: value,
      title: 'Вы действительно хотите удалить бюджет / дотацию?',
      data: 'Id=' + value + '&IsSubsidies=true&DeleteWithPayments=false',
      cb: data => {
        if (data.NeedDeletePayments) {
          message(context, {
            id: value,
            title: 'К бюджету / дотации привязаны платежи! Вы действительно хотите удалить?',
            data: 'Id=' + value + '&IsSubsidies=true&DeleteWithPayments=true',
            cb: data => {
              context.commit('list/remove', value);
              window.app.$message({
                type: 'success',
                message: 'Бюджет / дотация удален'
              });
              resolve();
            }
          });
          return;
        }
        if (data.NeedDeleteSubsidies) {
          message(context, {
            id: value,
            title: 'При удалении бюджета будут удалены дотации по нему. Продолжить?',
            data: 'Id=' + value + '&IsSubsidies=true&DeleteSubsidies=true',
            cb: data => {
              context.commit('list/remove', value);
              window.app.$message({
                type: 'success',
                message: 'Бюджет / дотация удален'
              });
              resolve();
            }
          });
          return;
        }
        context.commit('list/remove', value);
        window.app.$message({
          type: 'success',
          message: 'Бюджет / дотация удален'
        });
        resolve();
      }
    });
  });
}

function message(context, {title, id, cb, data}) {
  window.app.$confirm(title, 'Удаление бюджета / дотации №' + id, {
    confirmButtonText: 'Удалить',
    cancelButtonText: 'Отмена',
    type: 'info'
  }).then(() => {
    axios({
      method: 'post',
      url: '/tourclient/api/giftCertificate/delete',
      data,
      requestId: 'tourclient/api/giftCertificate/delete'
    }).then(({data}) => {
      cb(data);
    }).catch(e => {
      context.dispatch('error', e, {root: true});
    })
  }).catch(e => {
  });
}
